export interface MenuHelpInfo {
  helpCenterUrl: string;
  ticketsUrl: string;
}
